import { sumBy } from 'lodash';

import { IAppState } from '../../store';

export const selectOffersCount = (state: IAppState) => {
  const { offers } = state;

  return sumBy(offers, ({ count }) => Number(count));
};
